// extracted by mini-css-extract-plugin
export default {"Projects":"Projects_Projects__ZxhyM","Projects_active_imageupload":"Projects_Projects_active_imageupload__oJUsk"};